"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var authApi = exports.authApi = {
  login: function login(data) {
    return (0, _request.default)({
      url: '/auth/login',
      data: data,
      method: 'post'
    });
  },
  getInfo: function getInfo() {
    return (0, _request.default)({
      url: "/auth/profile",
      method: "get"
    });
  }
};